// LICENSE_CODE ZON
'use strict';
/*jslint browser:true, es6:true, node:true, react:true*/

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot, hydrateRoot } from 'react-dom-client';
import www_util from 'hola_pub_util';

class Error_boundary extends React.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      has_error: false
    });
  }

  static getDerivedStateFromError(error) {
    return {
      has_error: true
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      has_error: true
    });
    if (this.props.log) this.props.log(error, info);
  }

  render() {
    if (this.state.has_error) return this.props.error_ui || null;
    return this.props.children;
  }

}

export const dom_render = (comp, root, log = www_util.perr_react, new_api) => {
  if (typeof root == 'string') root = document.querySelector(root);

  if (new_api) {
    const react_root = createRoot(root);
    react_root.render( /*#__PURE__*/React.createElement(Error_boundary, {
      log: log
    }, comp));
  } else {
    ReactDOM.render( /*#__PURE__*/React.createElement(Error_boundary, {
      log: log
    }, comp), root);
  }
};
export const dom_hydrate = (comp, root, log = www_util.perr_react, new_api) => {
  if (typeof root == 'string') root = document.querySelector(root);
  if (new_api) hydrateRoot(root, /*#__PURE__*/React.createElement(Error_boundary, {
    log: log
  }, comp));else {
    ReactDOM.hydrate( /*#__PURE__*/React.createElement(Error_boundary, {
      log: log
    }, comp), root);
  }
};